export default __webpack_public_path__ + "static/media/clapping.f4be7f78.mp3";